import t from '@rcm/i18n-client';
import React, { ChangeEvent, useCallback, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useFindCurrentCountryRuleQuery } from '../../api';
import useShippingPostalCodeIsValidOnClient from '../../hooks/useShippingPostalCodeIsValidOnClient';
import { selectShippingPostalCode, setShippingPostalCode } from '../../slices/shipping';

const PostalCodeField = () => {
    const dispatch = useDispatch();
    const postalCode = useSelector(selectShippingPostalCode);
    const postalCodeIsValidOnClient = useShippingPostalCodeIsValidOnClient();
    const countryRulesQuery = useFindCurrentCountryRuleQuery();

    const [isTouched, setIsTouched] = useState(!!postalCode);

    const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        setIsTouched(true);
        dispatch(setShippingPostalCode(e.target.value));
    }, [dispatch]);

    return <Row className="mb-3">
        <Form.Group as={Col}>
            <Form.Label>{t('Postal Code')}</Form.Label>
            <Form.Control
                className={
                    (isTouched && !postalCodeIsValidOnClient) ?
                        'is-invalid' :
                        ''
                }
                disabled={countryRulesQuery.isLoading}
                value={postalCode}
                onChange={handleChange}
            />
        </Form.Group>
    </Row>;
}

export default PostalCodeField;
